module.exports = __webpack_public_path__ + "img/under-review.288b0aac.png";